/**
 * 死链
 */
import ToolkitApi from '../../api/toolkit.api'
const commonApi = new ToolkitApi('xenu');

const state = {
    url: '',
    token: ''
};

const getters = {
    // 是否完成状态
    isFinish: state => {
        return state.runStatus !== 2;
    }
};

const mutations = {
    // 设置检测参数
    setState(state, data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                state[key] = data[key];
            }
        }
    }
};

const actions = {
    //启动检测
    start({state, commit}, params) {
        return commonApi.start(params).then(res => {
            commit('setState', {url: params.url, token: res.token});
            return res;
        })
    },
    //获取进度数据
    getProgress({state}) {
        return commonApi.getProgress(state.token);
    },
    //获取结果数据
    getList({state}, params) {
        return commonApi.getList(state.token, params);
    },
    //取消检测
    cancel({state}) {
        return commonApi.cancel(state.token);
    },
    // 下载报告
    downloadReport({state}) {
        return commonApi.downloadReport({token: state.token});
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/xenu.js